import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const user = await exchangeGoogleSession(sessionId);
        // Clear the hash
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Welcome, seeker.");
        if (user.has_soul_record) navigate("/app/oracle", { replace: true });
        else navigate("/intake", { replace: true });
      } catch (e) {
        toast.error("The veil resisted. Please try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, exchangeGoogleSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#080808]">
      <div className="text-center">
        <div className="font-overline mb-4">Weaving your session</div>
        <div className="font-heading text-3xl text-[#F4EFE6]/80 breathe">◐</div>
      </div>
    </div>
  );
}
